import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from "@azure/msal-browser";
import { FailedComponent } from './components/failed/failed.component';

export const routes: Routes = [
  {
  path: '',
  loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule),
},
{
  path:'login-failed',
  component:FailedComponent
}
];

@NgModule({
  imports: [
    RouterModule.forRoot((routes), {
      useHash: true,
      initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
